<template>
  <CRow>
    <CCol cols="12" md="12" lg="12">
      <b-card header-tag="header" header-bg-variant="dark">
        <template #header>
          <p class="mb-0" style="">
            <strong>{{ $store.state.table.dokAdmin }}</strong>
          </p>
        </template>
        <CRow>
          <CCol cols="12" md="12" lg="12">
            <b-button variant="primary" class="mb-4" v-b-modal.modal-input>
              <CIcon name="cil-plus" />
              {{ $store.state.table.tambahModal }}
            </b-button>
          </CCol>
        </CRow>
        <CRow>
          <CCol>
            <CDataTable :items="items" :fields="fields" responsive sorter column-filter hover show-empty :loading="loading" @update:column-filter-value="onFilter($event)">
              <template #Actions="{ item }">
                <td>
                  <b-button
                    variant="warning"
                    class="mr-1"
                    v-c-tooltip.hover.click="$store.state.table.tooltipEdit"
                    v-b-modal.modal-edit
                    @click="data = item"
                    :disabled="$store.state.role_aktif.kodeRole != 'super' && !item.mitraId"
                  >
                    <CIcon name="cil-pencil" /> {{ item.actions }}
                  </b-button>
                  <b-button
                    variant="danger"
                    class="mr-1"
                    v-c-tooltip.hover.click="$store.state.table.tooltipHapus"
                    v-b-modal.modal-delete
                    @click="data = item"
                    :disabled="$store.state.role_aktif.kodeRole != 'super' && !item.mitraId"
                  >
                    <CIcon name="cil-trash" /> {{ item.actions }}
                  </b-button>
                </td>
              </template>
            </CDataTable>
            <MyPagination :entriesaw="entriesaw" :entriesak="entriesak" :totalRows="totalRows" :currentPage="currentPage" :perPage="perPage" @changeVar="changeVar" />
          </CCol>
        </CRow>
      </b-card>
    </CCol>
    <modal-input @alertFromChild="triggerAlert($event)" />
    <modal-edit :data="data" @alertFromChild="triggerAlert($event)" />
    <modal-delete :data="data" @alertFromChild="triggerAlert($event)" />
  </CRow>
</template>

<script>
import modalInput from "./modalInput.vue";
import modalEdit from "./modalEdit.vue";
import modalDelete from "./modalDelete.vue";

export default {
  components: {
    modalInput,
    modalEdit,
    modalDelete,
  },
  name: "dokAdmin",
  data() {
    return {
      data: {},
      items: [],
      filter: {},
      perPage: 10,
      totalRows: 0,
      currentPage: 1,
      loading: false,
    };
  },
  computed: {
    entriesaw() {
      return this.items.length != 0 && this.items ? this.items[0].no : 0;
    },
    entriesak() {
      return this.items.length != 0 && this.items ? this.items[this.items.length - 1].no : 0;
    },
    fields() {
      let x = [
        {
          key: "no",
          label: this.$store.state.table.no,
          sortDirection: "desc",
          class: "table-number text-center ",
          _style: "width: 1px;",
          filter: false,
          sorter: false,
        },
        {
          key: "namaKebutuhan",
          label: this.$store.state.table.namaKebutuhan,
          _style: "max-width: 85%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "Actions",
          label: this.$store.state.table.Actions,
          _style: "width: 10%;",
          class: "table-option-2 text-center",
          filter: false,
          sorter: false,
        },
      ];

      if (this.$store.state.role_aktif.kodeRole == "super") {
        x.splice(1, 0, {
          key: "namaMitra",
          label: "Mitra",
          _style: "width: 10%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        });
      }

      return x;
    },
  },
  mounted() {
    this.getDatas();
  },
  watch: {
    currentPage: function (newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
    perPage: function (newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
  },
  methods: {
    onFilter(x) {
      const vm = this;
      vm.filter = x;
      vm.currentPage = 1;
      vm.getDatas();
    },
    async getDatas() {
      const vm = this;
      vm.loading = true;
      let listDokAdministrasi = await vm.$axios.post("masterKebutuhan/listPerHalaman", {
        ...vm.filter,
        halaman: vm.currentPage - 1,
        jumlah: vm.perPage,
      });
      // console.log("listDokAdministrasi", listDokAdministrasi);
      vm.items =
        listDokAdministrasi.data.status == 200
          ? listDokAdministrasi.data.data.map((x, idx) => {
              return {
                ...x,
                no: (vm.currentPage - 1) * vm.perPage + idx + 1,
                id: x.masterKebutuhanId,
                namaMitra: x.namaMitra || " - ",
              };
            })
          : [];
      vm.totalRows = parseInt(listDokAdministrasi.data.count);
      vm.loading = false;
    },
    triggerAlert(event) {
      let vm = this;
      vm.$store.commit("set_alert", event);
      vm.getDatas();
    },
    changeVar({ name, data }) {
      this[name] = data;
    },
  },
};
</script>
